import { Timestamp } from "firebase/firestore";

/**
 * Devuelve la fecha actual en formato DD/MM/YYYY.
 * @returns {string} La fecha formateada.
 */

// Esta función calcula el próximo día hábil (lunes a viernes)
export const getNextBusinessDay = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  let dayOfWeek = tomorrow.getDay(); // Domingo = 0, Sábado = 6

  if (dayOfWeek === 6) { // Si es sábado
    tomorrow.setDate(tomorrow.getDate() + 2);
  } else if (dayOfWeek === 0) { // Si es domingo
    tomorrow.setDate(tomorrow.getDate() + 1);
  }
  
  tomorrow.setHours(0, 0, 0, 0); // Normaliza la hora
  return tomorrow;
};

// Esta función calcula la fecha de vencimiento de una caución
export const calculateVencimiento = (createdAt, dias) => {
    if (!createdAt?.toDate || typeof dias !== 'number') {
      return null;
    }
    const fechaCreacion = createdAt.toDate();
    const fechaVencimiento = new Date(fechaCreacion);
    fechaVencimiento.setDate(fechaVencimiento.getDate() + dias);
    fechaVencimiento.setHours(0, 0, 0, 0); // Normaliza la hora
    return fechaVencimiento;
};

export const getCurrentDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Enero es 0
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDate = (date) => {
    if (!date) return 'N/A';
    // Si es un timestamp de Firebase, lo convertimos a Date
    const dateObj = date instanceof Timestamp ? date.toDate() : new Date(date);
    return dateObj.toLocaleDateString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

// Hora de carga (HH:mm) de un registro. Se fija la zona horaria de Buenos Aires para que la
// planilla muestre la hora del mercado local aunque el equipo esté configurado en otro huso.
export const formatHoraForDisplay = (date) => {
    if (!date) return '-';
    const dateObj = date?.toDate ? date.toDate() : new Date(date);
    if (isNaN(dateObj.getTime())) return '-';
    return dateObj.toLocaleTimeString('es-AR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'America/Argentina/Buenos_Aires',
    });
};

// Suma N días hábiles (L-V) a una fecha base. days=0 devuelve la misma fecha normalizada a 00:00.
export const addBusinessDays = (baseDate, days) => {
    const start = baseDate instanceof Date ? new Date(baseDate) : new Date();
    const result = new Date(start);
    const n = Number(days) || 0;
    if (n === 0) {
        result.setHours(0, 0, 0, 0);
        return result;
    }
    let added = 0;
    const step = n > 0 ? 1 : -1;
    while (added < Math.abs(n)) {
        result.setDate(result.getDate() + step);
        const dow = result.getDay();
        if (dow !== 0 && dow !== 6) added += 1;
    }
    result.setHours(0, 0, 0, 0);
    return result;
};

// YYYY-MM-DD en zona local (sin convertir a UTC). Útil para keys de Firestore por día.
export const toIsoDate = (date) => {
    const d = date instanceof Date ? date : new Date(date);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};

// Inversa de toIsoDate: 'YYYY-MM-DD' a un Date local al inicio de ese día.
// (`new Date('2026-09-03')` lo interpretaría como UTC y correría la fecha.)
export const fromIsoDate = (iso) => new Date(`${iso}T00:00:00`);

// Calcula la fechaLiquidacion (YYYY-MM-DD) de una instrucción FCI a partir del plazo (T+0 / T+1) y la fecha base.
export const calcularFechaLiquidacionFci = (plazo, baseDate = new Date()) => {
    const n = plazo === 'T+1' ? 1 : 0;
    return toIsoDate(addBusinessDays(baseDate, n));
};